module.exports = __webpack_public_path__ + "static/media/17.4fa6284f.jpg";